import { Controller } from "@hotwired/stimulus"
import L from "leaflet"

// Renders a Leaflet map centred on the community (or the geocoded property) with a
// radius circle sized to the selected proximity band. When the proximity <select>
// changes, the circle resizes in lockstep with the LTV recalculation.
//
//   <div data-controller="map"
//        data-map-lat-value="50.26" data-map-lng-value="-119.27"
//        data-map-band-value="within_15_min_drive"
//        data-map-radii-value='{"within_15_min_drive":15000, ...}'
//        data-map-has-property-value="true"
//        data-map-property-lat-value="50.3" data-map-property-lng-value="-119.2">
//     <div data-map-target="container" class="h-64"></div>
//   </div>
export default class extends Controller {
  static targets = ["container"]
  static values = {
    lat: Number,
    lng: Number,
    band: String,
    radii: Object,
    hasProperty: Boolean,
    propertyLat: Number,
    propertyLng: Number
  }

  connect() {
    if (!this.latValue || !this.lngValue) return

    this.map = L.map(this.containerTarget, {
      scrollWheelZoom: false,
      attributionControl: true
    }).setView([this.latValue, this.lngValue], 11)

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap contributors",
      maxZoom: 18
    }).addTo(this.map)

    this.circle = L.circle([this.latValue, this.lngValue], {
      radius: this.currentRadius(this.bandValue),
      color: "#c2410c",
      weight: 2,
      fillColor: "#f97316",
      fillOpacity: 0.12
    }).addTo(this.map)

    if (this.hasPropertyValue && this.propertyLatValue && this.propertyLngValue) {
      L.circleMarker([this.propertyLatValue, this.propertyLngValue], {
        radius: 6,
        color: "#c2410c",
        fillColor: "#c2410c",
        fillOpacity: 0.9
      }).addTo(this.map)
    }

    this.fit()
  }

  disconnect() {
    if (this.map) {
      this.map.remove()
      this.map = null
    }
  }

  // Called from the proximity <select> via data-action="change->map#updateRadius"
  updateRadius(event) {
    if (!this.circle) return
    const band = event.target.value
    this.circle.setRadius(this.currentRadius(band))
    this.fit()
  }

  currentRadius(band) {
    return this.radiiValue[band] || 15000
  }

  fit() {
    if (this.circle) this.map.fitBounds(this.circle.getBounds(), { padding: [20, 20] })
  }
}
